module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "widget-screen"
  }, [_c('dash-header', {
    staticClass: "widget-header-container",
    attrs: {
      "date-range": _vm.$store.state.Dashboard.dateRange,
      "theme-header": "Conversion",
      "views": _vm.viewTypes,
      "bus": _vm.bus
    },
    on: {
      "date-range-changed": _vm.triggerUpdates,
      "range-config-updated": _vm.triggerUpdates
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "widgetPaddingLeft",
    attrs: {
      "xs9": ""
    }
  }, [_c('excel-download-button', {
    attrs: {
      "view": "conversion"
    }
  }), _vm._v(" "), _c('v-tabs', {
    staticClass: "widgetTabs",
    attrs: {
      "dark": "",
      "slider-color": "yellow",
      "icons-and-text": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    key: "count",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": _vm.tabClicked
    }
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "tabTitle"
  }, [_c('strong', [_vm._v("Conversion by Count")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.totalCount))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "totalCountConverted",
    staticStyle: {
      "color": "blue !important"
    }
  }, [_vm._v(_vm._s(_vm.totalCountConverted) + " "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_circle")])]), _vm._v(" "), _c('td', {
    staticClass: "totalCountUnconverted",
    staticStyle: {
      "color": "red !important"
    }
  }, [_vm._v(_vm._s(_vm.totalCountUnconverted) + " "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])])])])]), _vm._v(" "), _c('v-tab', {
    key: "value",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": _vm.tabClicked
    }
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "tabTitle"
  }, [_c('strong', [_vm._v("Conversion by Value")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h2', [_vm._v("R" + _vm._s(_vm.totalValue))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "totalValueConverted",
    staticStyle: {
      "color": "blue !important"
    }
  }, [_vm._v("R" + _vm._s(_vm.totalValueConverted) + " "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_circle")])]), _vm._v(" "), _c('td', {
    staticClass: "totalValueUnconverted",
    staticStyle: {
      "color": "red !important"
    }
  }, [_vm._v("R" + _vm._s(_vm.totalValueUnconverted) + " "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")])])])])]), _vm._v(" "), _c('v-tab', {
    key: "percentage",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": _vm.tabClicked
    }
  }, [_c('table', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tabTitle"
  }, [_c('strong', [_vm._v("Conversion % by Count")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h2', [_vm._v(_vm._s(_vm.totalPercent))])])])])]), _vm._v(" "), _c('v-tab', {
    key: "percentageByValue",
    attrs: {
      "ripple": ""
    },
    on: {
      "click": _vm.tabClicked
    }
  }, [_c('table', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tabTitle"
  }, [_c('strong', [_vm._v("Conversion % by Value")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('h2', [_vm._v(_vm._s(_vm.totalValuePercent))])])])])]), _vm._v(" "), _c('v-tab-item', {
    key: "count",
    attrs: {
      "lazy": true
    }
  }, [_c('v-card', {
    staticClass: "justify-center align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.loading) ? _c('conversion-count', {
    attrs: {
      "view-data": _vm.dataView.count,
      "date-range": _vm.$route.params.dateRange,
      "updateData": _vm.updateComponents,
      "bus": _vm.bus
    },
    on: {
      "widgets-updated": _vm.resetTrigger,
      "conversion-bar-selected": _vm.updateViewByBarSelection
    }
  }) : _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../../shared/assets/images/3dloader.gif")
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "value",
    attrs: {
      "lazy": true
    }
  }, [_c('v-card', {
    staticClass: "justify-center align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.loading) ? _c('conversion-value', {
    attrs: {
      "view-data": _vm.dataView.value,
      "date-range": _vm.$route.params.dateRange,
      "updateData": _vm.updateComponents,
      "bus": _vm.bus
    },
    on: {
      "conversion-bar-selected": _vm.updateViewByBarSelection
    }
  }) : _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../../shared/assets/images/3dloader.gif")
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "percentage",
    attrs: {
      "lazy": true
    }
  }, [_c('v-card', {
    staticClass: "justify-center align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.loading) ? _c('conversion-percentage', {
    attrs: {
      "view-data": _vm.dataView.percent,
      "date-range": _vm.$route.params.dateRange,
      "updateData": _vm.updateComponents,
      "bus": _vm.bus
    },
    on: {
      "conversion-bar-selected": _vm.updateViewByBarSelection
    }
  }) : _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../../shared/assets/images/3dloader.gif")
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "percentageByValue",
    attrs: {
      "lazy": true
    }
  }, [_c('v-card', {
    staticClass: "justify-center align-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.loading) ? _c('conversion-percentage', {
    attrs: {
      "view-data": _vm.dataView.percentByValue,
      "date-range": _vm.$route.params.dateRange,
      "updateData": _vm.updateComponents,
      "bus": _vm.bus
    },
    on: {
      "conversion-bar-selected": _vm.updateViewByBarSelection
    }
  }) : _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../../shared/assets/images/3dloader.gif")
    }
  })], 1)], 1)], 1), _vm._v(" "), (this.$store.state.Dashboard.widgetConfig.viewType === 'date_range' && this.loading === false) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-40px",
      "z-index": "9999",
      "text-align": "center"
    }
  }, [_c('small', [_vm._v("Based on Quote Origination date")])]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "widgetPaddingRight",
    attrs: {
      "xs3": ""
    }
  }, [_c('filters', {
    attrs: {
      "bus": _vm.bus,
      "filters": _vm.filters
    },
    on: {
      "apply-filters": _vm.setFilters
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}